const ShowcaseContent = () => {
    return ( 
        <>
            <div className="showcase-content">
                <h4>We Have Been Serving</h4>
                <h1>COFFEE</h1>
                <h4 style={{color: '#fff'}}>* SINCE 1950 *</h4>
            </div>
        </>
     );
}   
 
export default ShowcaseContent;